import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { HisBaseGlobalsService } from 'hisng';
import { formatDate } from '@angular/common';
import {
    ENGLISH_DATE_TIME_FORMAT_PLACEHOLDER,
    ENGLISH_DATE_TIME_PIPE_FORMAT,
    GERMAN_DATE_TIME_FORMAT_PLACEHOLDER,
    GERMAN_DATE_TIME_PIPE_FORMAT
} from 'app/rm/erp/common/model/constants';
import { TravelAbroad } from '../../model/travelabroad';

@Component( {
    selector: 'erp-businesstripapplication-travel-abroad',
    templateUrl: './businesstripapplication-travel-abroad.component.html'
} )
export class BusinesstripApplicationTravelAbroadComponent implements OnInit, OnChanges {
    @Input() listTravelAbroad?: TravelAbroad[] | null = [];
    @Output() travelAbroadChange = new EventEmitter<TravelAbroad[]>();
    readonly currentDate: string = formatDate( Date.now(), 'yyyy-MM-dd', 'de-DE' );
    readonly dateTimeFormat: string;
    readonly dateTimePlaceholderFormat: string;
    public travelAbroad: TravelAbroad = new TravelAbroad();
    private tempTravelAbroadPosition: number | null = null;
    public isInputDialogVisible = false;
    public isDeleteAllButtonDisabled = true;

    constructor(
        private readonly hisBaseGlobalsService: HisBaseGlobalsService,
    ) {
        if ( this.hisBaseGlobalsService.getLanguage() === 'de' ) {
            this.dateTimeFormat = GERMAN_DATE_TIME_PIPE_FORMAT;
            this.dateTimePlaceholderFormat = GERMAN_DATE_TIME_FORMAT_PLACEHOLDER;
        } else {
            this.dateTimeFormat = ENGLISH_DATE_TIME_PIPE_FORMAT;
            this.dateTimePlaceholderFormat = ENGLISH_DATE_TIME_FORMAT_PLACEHOLDER;
        }
    }
    ngOnInit(): void {
    }

    openInputDialog(): void {
        this.isInputDialogVisible = true;
    }

    closeInputDialog(): void {
        this.isInputDialogVisible = false;
    }

    createTravelAbroadAndOpenInputDialog(): void {
        this.travelAbroad = new TravelAbroad();
        this.tempTravelAbroadPosition = null;
        this.openInputDialog();
    }

    editTravelAbroadAndOpenInputDialog( elementPosition: number ) {
        if ( this.listTravelAbroad && this.listTravelAbroad.length > elementPosition ) {
            let tempAbroad: TravelAbroad | undefined = this.listTravelAbroad[elementPosition];
            if ( tempAbroad ) {
                this.travelAbroad = { ...tempAbroad };
                this.tempTravelAbroadPosition = elementPosition;
            }
            this.openInputDialog();
        }
    }

    addTravelAbroadToListAndCloseInputDialog(): void {
        if ( this.listTravelAbroad ) {
            if ( this.tempTravelAbroadPosition !== null ) {
                this.listTravelAbroad[this.tempTravelAbroadPosition] = this.travelAbroad;
            } else {
                this.listTravelAbroad.push( this.travelAbroad );
            }
            this.closeInputDialog();
            this.setIsDeleteButtonToShow();
            this.travelAbroadChange.emit( this.listTravelAbroad );
        }
    }

    deleteTravelAbroad( elementPosition: number ) {
        if ( this.listTravelAbroad && this.listTravelAbroad.length > elementPosition ) {
            this.listTravelAbroad.splice( elementPosition, 1 );
            this.setIsDeleteButtonToShow();
            this.travelAbroadChange.emit( this.listTravelAbroad );
        }
    }

    deleteAllTravelAbroad(): void {
        if ( this.listTravelAbroad && this.listTravelAbroad.length > 0 ) {
            this.listTravelAbroad.splice( 0, this.listTravelAbroad.length );
            this.setIsDeleteButtonToShow();
            this.travelAbroadChange.emit( this.listTravelAbroad );
        }
    }

    setIsDeleteButtonToShow(): void {
        if ( this.listTravelAbroad && this.listTravelAbroad.length > 0 ) {
            this.isDeleteAllButtonDisabled = false;
        } else {
            this.isDeleteAllButtonDisabled = true;
        }
    }

    ngOnChanges( changedValue: SimpleChanges ): void {
        // Necessary if inputvalue is provided by parent component
        this.setIsDeleteButtonToShow();
    }
}
